import { render, staticRenderFns } from "./NutritionLegend.vue?vue&type=template&id=ec2b51fe&scoped=true&"
import script from "./NutritionLegend.vue?vue&type=script&lang=js&"
export * from "./NutritionLegend.vue?vue&type=script&lang=js&"
import style0 from "./NutritionLegend.vue?vue&type=style&index=0&id=ec2b51fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2b51fe",
  null
  
)

export default component.exports